module.exports = function getResource(label, vars = []) {
    let resources = {
        selectBrand: 'Sélectionnez votre marque de fond de teint actuelle'
    };

    return resources[label];
};
